export function roundToPlaces(dec, places) {
  let factor = Math.pow(10, places);
  return (Math.round(dec * factor)) / factor;
}